/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="16.04"
        height="13.03"
        viewBox="0 0 16.04 13.03"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M690.62,382.3a9.36,9.36,0,0,1-14.41,7.88,6.84,6.84,0,0,0,.79.05,6.59,6.59,0,0,0,4.08-1.41,3.31,3.31,0,0,1-3.07-2.29,3.18,3.18,0,0,0,.62.06,3.58,3.58,0,0,0,.87-.11,3.29,3.29,0,0,1-2.64-3.23v0a3.25,3.25,0,0,0,1.49.41,3.28,3.28,0,0,1-1-4.39,9.35,9.35,0,0,0,6.78,3.44,3.74,3.74,0,0,1-.08-.75,3.29,3.29,0,0,1,3.29-3.29,3.32,3.32,0,0,1,2.4,1,6.6,6.6,0,0,0,2.09-.79,3.32,3.32,0,0,1-1.45,1.82,6.61,6.61,0,0,0,1.89-.52,6.63,6.63,0,0,1-1.64,1.7C690.62,382,690.62,382.15,690.62,382.3Z"
          transform="translate(-676.21 -378.63)"
          className="icon-fill"
          fillRule="evenodd"/>
      </svg>

    );
  }
}

Icon.displayName = 'TwitterIcon';

export default Icon;
